import { useMemo } from 'react'

import { useFeature } from '../../../../../store/features'
import { getSchema } from '../../../sharedSchemaFragments/nlpSettings/constants'
import {
  useIsNlpKbChatProviderEnabled,
  useAreNlpIntentsWithDescriptionEnabled
} from '../../../../../store/botNlp/hooks'

export function useSchema() {
  const areNlpProvidersEnabled = !!useFeature('NLP_PROVIDERS')
  const isNlpKbChatProviderEnabled = useIsNlpKbChatProviderEnabled()
  const areIntentsWithDescriptionEnabled = useAreNlpIntentsWithDescriptionEnabled()

  return useMemo(
    () =>
      getSchema(
        areNlpProvidersEnabled,
        isNlpKbChatProviderEnabled,
        areIntentsWithDescriptionEnabled
      ),

    [areNlpProvidersEnabled, isNlpKbChatProviderEnabled, areIntentsWithDescriptionEnabled]
  )
}
